
  export default {
    name: 'TopBanner',
    data() {
      return {
        showBanner: false, 
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll); // Add scroll event listener
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll); // Clean up event listener
    },
    methods: {
      handleScroll() {
        // Show banner after scrolling down 100 pixels
        this.showBanner = window.scrollY > 100;
      },
    },
  };
  